import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, URLSearchParams, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/map'
import { User } from 'app/users/shared/user.model';
import { UserFactory } from '../users/shared/user.factory';
import { Subject } from 'rxjs/Subject';
import { ToastsManager } from 'ng2-toastr';
import { retry, map, catchError } from 'rxjs/operators';
import { Message } from 'app/messages/messages.model';
import { MessageFactory } from 'app/messages/shared/message.factory';
import { SettingFactory } from 'app/settings/shared/setting.factory';
import { HttpHeaders } from '@angular/common/http';
import { Setting } from 'app/settings/shared/setting.model';

@Injectable()
export class GlobalService {

    public currentUserHasChanged = false;
    public currentSetting: Setting = SettingFactory.empty();
    public currentUser: User = UserFactory.empty();
    private currentUserSource = new Subject<any>();
    public $currentUser = this.currentUserSource.asObservable();

    constructor(private http: Http, public toastr: ToastsManager) { }

    public updateCurrentUser(user: User) {
        if (this.currentUser && user.id !== this.currentUser.id) {
            this.currentUserHasChanged = true;
        }
        this.currentUser = user;
        this.currentUserSource.next(user);
    }

    downloadFile(file: string): Observable<Blob> {
        const token = localStorage.getItem('token');
        const headers = new Headers({ 'Authorization': 'bearer ' + token });
        const options = new RequestOptions({ responseType: ResponseContentType.Blob, headers: headers });
        return this.http.get(environment.apiUrl + file, options)
            .map(res => res.blob())
        // .catch(this.handleError)
    }

    getMessage(uid: string, mid: string): Observable<any> {
        return this.http
            .get(`${environment.apiUrl}/readmessage?uid=${uid}&mid=${mid}`, {})
            .map((response: Response) => this.fromMessageObject(response.json()));
    }

    getMessageReply(uid: string, mid: string, rid: string): Observable<any> {
        return this.http
            .get(`${environment.apiUrl}/readreply?uid=${uid}&mid=${mid}&rid=${rid}`, {})
            .map((response: Response) => this.fromReplyObject(response.json()));
    }

    readMessage(userSourceId: string, userDestId: string, mid: string): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/readmessage`, { id: mid, userId: userDestId, userSourceId }, {})
            .pipe(map(item => MessageFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    version() {
        return this.http.get(`${environment.apiUrl}/version`).map((response: Response) => response.json());
    }

    public handleError(error: any) {
        const message = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        // this.toasterService.pop('error', 'Error', message);
        console.error('handleError', error)
        this.toastr.error(message, 'Fehler');
    }

    public showMessage(title: string, message: string) {
        // this.toasterService.pop('success', title, message);
        this.toastr.success(message, title);
    }

    public showMessageCustom(path: string, content: string) {
        this.toastr.custom(content, null, { data: { path }, enableHTML: true, showCloseButton: true, toastLife: 20000 });
    }

    public generateUUID(): string {
        let d = new Date().getTime(),
            d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
        });
    }

    private fromMessageObject(raw: any): any {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return {
            message: MessageFactory.fromObject(raw.data.message),
            settings: SettingFactory.fromObject(raw.data.settings),
        }
    }

    private fromReplyObject(raw: any): any {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return MessageFactory.fromObject(raw.data)
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/global.service.ts